import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconedBox } from 'views/rebranded-module/common/components/UI/NewMainWidget/IconedBox';


const StyledGrid = styled(Grid)(({ theme }) => ({
  '&.tourWidget': {
    alignItems: 'center',
  },
  '& .TWFieldContainer':{
    border: `1px solid ${theme.palette.border[3]}`,
    borderRadius:  theme.spacing(0.5),
    overflow: 'hidden',
    paddingTop: 0,
  },
  '& .TWInputField': {
    '& .WidgetInputLabel': {
      left: theme.typography.pxToRem(56),
      color: theme.palette.grey[300],
    },
    '& .IBIcon': {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  }
}));

export const StyledIconedBox = styled(IconedBox)(({ theme }) => ({
  '& .WidgetInputLabel': {
    position: 'absolute',
    fontSize: theme.typography.pxToRem(10),
    textTransform: 'uppercase',
    lineHeight: theme.typography.pxToRem(10),
    color: theme.palette.text.secondary,
    left: theme.spacing(92),
    top: theme.spacing(2.25),
    zIndex: 1,
  },
}));

export default StyledGrid;
